/**
 * Credits Bar — renders credits balance, daily free counter, claim button, streak
 * Ported from studio: uses workspace store + eventBus
 */

import { store } from '../../core/store.js'
import { eventBus, EVENTS } from '../../core/event-bus.js'
import { fetchCreditsStatus } from '../../api/credits.js'

/**
 * Render the credits bar into #stageActions (stage header area)
 */
export function renderCreditsBar() {
  const container = document.getElementById('stageActions')
  if (!container) return

  const credits = store.getState('credits')
  const { balance, dailyFreeUsed, dailyFreeRemaining, dailyFreeLimit, streak, dailyLoginClaimed } =
    credits
  const isLoggedIn = !!store.getState('auth.token')

  // The balance endpoint is retired (H-079) — until a replacement read model
  // lands, a logged-in user with no data must see NO bar, not "0/0 credits".
  if (!isLoggedIn || !store.getState('credits.available')) {
    // Remove credits bar if present (keep other stage actions)
    const existing = container.querySelector('.ws-credits-bar')
    if (existing) existing.remove()
    return
  }

  let bar = container.querySelector('.ws-credits-bar')
  if (!bar) {
    bar = document.createElement('div')
    bar.className = 'ws-credits-bar'
    container.prepend(bar)
  }

  bar.innerHTML = `
    <span class="ws-credits-free">Free: ${Number(dailyFreeRemaining) || 0}/${Number(dailyFreeLimit) || 0} today</span>
    <span class="ws-credits-divider">|</span>
    <span class="ws-credits-balance">Credits: ${Math.floor(Number(balance) || 0)}</span>
    ${Number(streak) > 0 ? `<span class="ws-credits-streak">${Number(streak)}d streak</span>` : ''}
  `
}

/**
 * Initialize credits — fetch status and render bar
 */
export async function initCredits() {
  const token = store.getState('auth.token')
  if (!token) return

  const res = await fetchCreditsStatus()
  const status = res?.data || res
  store.setState('credits.available', !!status)
  if (status) {
    store.setState('credits.balance', status.balance || 0)
    store.setState('credits.dailyFreeUsed', status.daily_free_used || 0)
    store.setState('credits.dailyFreeRemaining', status.daily_free_remaining ?? 10)
    store.setState('credits.dailyFreeLimit', status.daily_free_limit || 10)
    store.setState('credits.streak', status.streak || 0)
    store.setState('credits.dailyLoginClaimed', status.daily_login_claimed || false)
  }
  renderCreditsBar()
}

// Re-render credits bar on auth changes
eventBus.on(EVENTS.AUTH_CHANGED, () => {
  if (store.getState('auth.token')) {
    initCredits()
  } else {
    renderCreditsBar()
  }
})

// Re-render after generation completes (balance may have changed)
eventBus.on(EVENTS.GENERATION_COMPLETE, () => {
  initCredits()
})
